import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentBadge12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDocumentBadge12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.917 1H2.5a.5.5 0 0 0-.5.5V7h4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2v.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V5.083H5.917zM1 10v.5A1.5 1.5 0 0 0 2.5 12h7a1.5 1.5 0 0 0 1.5-1.5V4.568a2 2 0 0 0-.643-1.47L7.575.53A2 2 0 0 0 6.218 0H2.5A1.5 1.5 0 0 0 1 1.5V7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1m0-1h5V8H1zm8.875-4.917a1 1 0 0 0-.197-.25l-2.761-2.55v2.8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentBadge12);
